module.exports = __webpack_public_path__ + "img/Julia3.779b2d14.png";